const markupToggles = document.querySelectorAll('[data-toggle]')
const fadeDuration = 0.3;

for (const toggle of markupToggles) {
    const toggleMe = document.getElementById(toggle.dataset.toggle)

    toggle.onclick = (e) => {
        e.preventDefault()
        if (toggleMe.style.display === 'none') {
            toggleMe.style.display = null
            setTimeout(() => toggleMe.style.opacity = 1)
        } else if(toggleMe.style.opacity === '1') {
            toggleMe.style.opacity = 0
            setTimeout(() => toggleMe.style.display = 'none', 200)
        }
    }

    toggleMe.style.opacity = toggleMe.style.display === 'none' ? 0 : 1
    toggleMe.style.transition = `opacity ${fadeDuration}s ease-in-out`
}
